var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"button",class:{
    button__secondary: _vm.type === 'secondary',
    button__default: _vm.type === 'default',
    button__float: _vm.type === 'float',
    button_disabled: _vm.disabled,
    button_enabled: !_vm.disabled,
  },attrs:{"target":_vm.target,"href":_vm.href,"disabled":_vm.disabled || _vm.loading},on:{"click":_vm.click}},[(_vm.loading)?_c('v-progress-circular',{staticClass:"mr-2",staticStyle:{"position":"absolute","left":"1em","top":"50%","transform":"translateY(-50%)","z-index":"1000"},attrs:{"width":1,"color":"white","size":20,"indeterminate":""}}):_vm._e(),_c('span',{staticClass:"animate",style:(("margin-left: " + (_vm.loading ? '2.5em' : 0)))},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }